import React, { useEffect, useState } from "react";
import { Button, Col, Form, Row, Input, FormGroup, Label } from "reactstrap";
import NumberFormat from "react-number-format";
import Select from "react-select";
import Swal from "sweetalert2";
import tooltipText from "../../Forms/ShortCutComponents/tooltipText";
// import { AppSwitch } from "@coreui/react";
import {
  checkPermission,
  checkPermissionSilent,
  check_Bussiness_Permission,
  getBulkItemQtyAmt,
} from "../../../Helper";
import JvPreviewModal from "../../Forms/ShortCutComponents/JvPreviewModal";
import "./pos.css";
import moment from "moment";
import swal from "@sweetalert/with-react";
import { baseurl } from "../../../baseurl";
import { Link } from "react-router-dom";
import axios from "axios";
import { GetIp } from "../../Forms/ShortCutComponents/Get_ip";
import ReactDatePicker from "../../Forms/ShortCutComponents/ReactDatePicker";
import ResponseLoader from "../../Forms/ShortCutComponents/ResponseLoader";
// import { CheckClosingYearD } from "../../../ShortFunction/CheckClosingYearD";
import { CheckClosingYearD } from "../../Forms/ShortFunction/CheckClosingYearD";
import PendingTransferDemandModal from "./pendingTransferDemandModal";
import { SelectButton } from "primereact/selectbutton";
import "primereact/resources/themes/lara-light-indigo/theme.css"; // Replace with your chosen theme
import "primereact/resources/primereact.min.css"; // PrimeReact core CSS
import "primeicons/primeicons.css"; // PrimeIcons if needed

const username = localStorage.getItem("username");
const token = localStorage.getItem("token");
const companyId = localStorage.getItem("companyId");

export default function KitcenItemForm(props) {
  const options = ["Off", "On"];
  // ye state disable krne k lie he
  const [disabledState, setDisabledState] = useState(false);
  // ye state updateCheck krne k lie he
  const [updateCheck, setUpdateCheck] = useState(false);
  const [pk_id, setPk_id] = useState(null);

  const [loadingResponce, setLoadingResponce] = useState(false);
  const [getDataUom, setGetDataUom] = useState([]);
  const [getDataItemType, setGetDataItemType] = useState([]);
  const [itemLov1, setItemLov1] = useState([]);
  const [subInvLov, setSubInvLov] = useState([]);
  const [showSchedule, setShowSchedule] = useState(options[0]);
  const [showModal, setShowModal] = useState(false);
  const [canViewJv, setCanViewJv] = useState(false);
  const [jvModalOpen, setJvModalOpen] = useState(false);
  // Seeded from the row the overview handed over, then replaced by the value the
  // server returns -- on load from getInventoryMasterMtId, and after a save from
  // the posting response. That way the button also appears on a freshly saved
  // transfer, which has no rowData behind it.
  const [jvJournalId, setJvJournalId] = useState(
    props?.location?.state?.rowData?.journal_id || null,
  );

  const [recipeQty, setRecipeQty] = useState(0);
  const [date, setDate] = useState(new Date());
  const [mainDate, setMainDate] = useState();
  const [productionNumber, setProductionNumber] = useState();
  const [remarks, setRemarks] = useState();
  const [fSubInv, setFSubInv] = useState();
  const [tSubInv, setTSubInv] = useState();
  const [mainArray, setMainArray] = useState();
    const [db, setDB] = useState({
      isEggSpectation: false,
    });

  const [data, setData] = useState({
    formValues: [
      {
        lineNum: 1,
        itemType: null,
        itemTypeId: null,
        itemLov: [],
        itemCode: null,
        itemCodeLov: [],

        itemDescription: "",
        uomName: "",
        recipeQty: recipeQty,
        dQty: null,
        itemRate: null,
        recipeAmount: null,
        stockQty: null,
        remarks: "",
      },
    ],
    itemType: "",
    itemCat: "",
  });
  const [totalValues, setTotalValues] = useState({
    totalQty: 0,
    totalAmount: 0,
  });

  const removeFormFieldsItem = (i) => {
    let formValues = data.formValues;

    if (formValues.length > 1) {
      let totalqty = 0;
      let totalamount = 0;
      let totaldiscount = 0;
      let totalnet = 0;
      let totalTireDisposal = 0;
      let totslAmountIncAll = 0;
      let labour = data.labour;
      let tireDisposalLov = data.tireDisposalLov;
      let totalTireFee = 0;
      let sumSaleTaxVal = 0;

      formValues.splice(i, 1);
      reCalculate(formValues);

      for (let index = 0; index < formValues.length; index++) {
        totalqty = parseFloat(totalqty) + parseFloat(formValues[index]["qty"]);
        totalamount =
          parseFloat(totalamount) + parseFloat(formValues[index]["amount"]);
        totaldiscount =
          parseFloat(totaldiscount) + parseFloat(formValues[index]["discount"]);
        totalnet =
          parseFloat(totalnet) + parseFloat(formValues[index]["netAmount"]);

        totalTireDisposal += +formValues[index]["tireDisposal"];

        sumSaleTaxVal += +formValues[index]["fetTaxAmount"];

        if (formValues[index]["isChecked"] == true) {
          totalTireFee += +parseFloat(1.75 * formValues[index]["qty"]);
        }
        totslAmountIncAll =
          parseFloat(totalnet ? totalnet : 0) +
          parseFloat(totalTireDisposal ? totalTireDisposal : 0) +
          parseFloat(totalTireFee ? totalTireFee : 0) +
          parseFloat(labour ? labour : 0);
        formValues[index]["lineNum"] = index + 1;
      }
      setData({
        ...data,
        formValues,
        totalqty,
        totalamount,
        totaldiscount,
        totalnet,
        totalTireDisposal,
        totalTireFee,
        totslAmountIncAll,
        sumSaleTaxVal: sumSaleTaxVal,
      });
    } else {
      swal({
        title: "Invalid!",
        text: "Atleast 1 row should be selected!",
        icon: "error",
      });
    }
  };

  const handleChangeOpen = (e) => {
    setData({
      ...data,
      subInv: e,
    });
  };

  const addFormFieldsItem = () => {
    let lineNumber = data.formValues.length + 1;
    setData({
      ...data,
      formValues: [
        ...data.formValues,
        {
          // itemLov: getDataItemType.itemTypeOptions,
          itemCodeLov: getDataUom,
          lineNum: lineNumber,
          itemCode: null,
          itemRate: null,
          recipeQty: recipeQty,
        },
      ],
      show: false,
    });
  };
  const selectUOMEvent = async (uomField, index) => {
    const { qty, rate } = await itemQtyAmt(uomField?.id);
    // console.log(
    //   `Item ID: ${getItemData[i].id}, Quantity: ${qty}, Rate: ${rate}`
    // );
    // Optionally, update the getItemData array with qty and rate
    let formValues = data.formValues;

    formValues[index]["uom"] = uomField;
    formValues[index]["uomName"] = uomField?.uomDesc;
    formValues[index]["recipeQty"] = qty;
    formValues[index]["stockQty"] = qty;
    formValues[index]["itemRate"] = rate;
    formValues[index]["recipeAmount"] = qty * rate;
    // setData({
    //   ...data,
    //   formValues,
    // });

    if (uomField?.id) {
      let formValues = data.formValues;
      let itemId = uomField?.id;
      // formValues[index]["recipeQty"] = 0;
    } else {
      let formValues = data.formValues;
      formValues[index]["itemType"] = null;
      formValues[index]["itemDescription"] = "";
      formValues[index]["uomName"] = "";
      formValues[index]["itemRate"] = 0;
      formValues[index]["uom"] = "";
      formValues[index]["itemRate"] = "";
      formValues[index]["recipeQty"] = 0;
      formValues[index]["dQty"] = 0;
      formValues[index]["recipeAmount"] = "";

      reCalculate(formValues);
      
    }
    setData({
        ...data,
        formValues,
      });
  };
  const stringToNumber = (str) => {
    let newValue = 0;
    if (str) {
      newValue = Number(str?.toString()?.replaceAll(",", ""));
    }

    return newValue;
  };

  const handleFromChangeOpen = (e) => {
    let formValues = data.formValues;
    const id = formValues[0]["uom"]?.id;
    if (id || formValues.length > 1) {
      Swal.fire({
        title: "Are you sure?",
        text: "Detail part will Destroyed!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, destroyed it!",
      }).then((result) => {
        if (result.isConfirmed) {
          if (e?.id === tSubInv?.id) {
            swal({
              title: "Warning",
              text: "From and To Subinventory Locations can't be same!",
              icon: "warning",
            });
            setFSubInv(null);
          } else {
            setFSubInv(e);
          }
          let nulArr = [];
          const nulObj = {
            lineNum: 1,
            uom: null,
            uomName: "",
            recipeQty: 0,
            dQty: 0,
            itemRate: 0,
            recipeAmount: 0,
            remarks: "",
          };
          setTotalValues({
            ...totalValues,
            totalQty: 0,
            totalAmount: 0,
          });
          nulArr.push(nulObj);
          setData({
            ...data,
            formValues: nulArr,
          });
        }
      });
    } else {
      if (e?.id === tSubInv?.id) {
        swal({
          title: "Warning",
          text: "From and To Subinventory Locations can't be same!",
          icon: "warning",
        });
        setFSubInv(null);
      } else {
        setFSubInv(e);
      }
    }
  };
  const handleToChangeOpen = (e) => {
    if (e?.id === fSubInv?.id) {
      swal({
        title: "Warning",
        text: "From and To Subinventory Locations can't be same!",
        icon: "warning",
      });
      setTSubInv(null);
    } else {
      setTSubInv(e);
    }
  };

  const reCalculate = (formValues) => {
    let totalQty = 0;
    let totalAmount = 0;
    for (let loop = 0; loop < formValues.length; loop++) {
      const element = formValues[loop];
      totalQty += stringToNumber(element.recipeQty);
      totalAmount += stringToNumber(element.recipeAmount);
    }
    setTotalValues({
      ...totalValues,
      totalQty,
      totalAmount,
    });
  };
  const selectItemTypeEvent = (itemTypeField, index) => {
    let itemTypeId = itemTypeField?.id;
    let formValues = data.formValues;

    formValues[index]["itemType"] = itemTypeField;

    formValues[index]["uom"] = 0;
    formValues[index]["itemDescription"] = 0;
    formValues[index]["uomName"] = 0;
    formValues[index]["recipeQty"] = 0;
    formValues[index]["itemRate"] = 0;
    formValues[index]["recipeAmount"] = 0;

    reCalculate(formValues);
    setData({
      ...data,
      formValues,
    });

    itemCodeLov(itemTypeId, index);
  };

  const itemCodeLov = () => {
    axios
      .post(
        `${baseurl}/lovs/getItem`,

        { companyId: companyId, username: username, 
          // minusComboDeal: true, // Noman ne bnd krwai he sb k lie
         },
        {
          headers: {
            authorization: token,
          },
        }
      )
      .then(function (response) {
        let mydata = [];
        let responseData = response.data.data;

        for (let loop = 0; loop < responseData.length; loop++) {
          mydata.push({
            id: responseData[loop]["ITEM_ID"],
            value: responseData[loop]["ITEM_ID"],
            label:
              responseData[loop]["ITEM_CODE"] +
              " " +
              responseData[loop]["ITEM_DESC"],
            itemCode: responseData[loop]["ITEM_CODE"],
            ItemDescription: responseData[loop]["ITEM_DESC"],
            uomDesc: responseData[loop]["UOM_DESC"],
            uomId: responseData[loop]["UOM_ID"],
            ItemRate: responseData[loop]["ItemRate"],
          });
        }

        setItemLov1(mydata);
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  const itemQtyAmt = async (id, fr_sub_inv_id) => {
    try {
      // console.log(fSubInv);
      const response = await axios.post(
        `${baseurl}/lovs/getItemQtyAmt`,
        {
          companyId: companyId,
          username: username,
          id: id,
          sub_inv_id: fr_sub_inv_id ? fr_sub_inv_id : fSubInv?.id,
          date: date ? moment(date).format("YYYY-MM-DD") : "",
          qtyCheck: true,
        },
        {
          headers: {
            authorization: token,
          },
        }
      );

      // Extract data from the response
      let amount = response.data.data1[0]?.funItemAmt || 0; // Default to 0 if undefined
      let qty = response.data.data2[0]?.funItemQty || 0; // Avoid division by 0
      let stockQty = response.data.data2[0]?.funItemQty || 0; // Avoid division by 0
      const rate = amount / qty || 0;

      // Return the values
      return { qty, rate, amount, stockQty };
    } catch (error) {
      console.error("Error fetching item quantity and amount:", error);
      return { qty: 0, rate: 0 }; // Return default values in case of an error
    }
  };

  // One /lovs/getBulkItemQtyAmt round-trip for a whole detail grid instead of one
  // getItemQtyAmt per line. The procedure behind it (FUN_ITEM_QTY_AMT_BULK) is the
  // bulk form of the same FUN_ITEM_QTY / FUN_ITEM_AMT pair the per-row call used,
  // so item_Qty and item_Rate are the same numbers (rate = amount / qty, 0 when
  // there is no stock) -- switching to it changes the speed, not the figures.
  //
  // `asOfDate` is always passed in and never read from the `date` state: a caller
  // that has just called setDate() still sees the previous value through its
  // closure, which reads stock at the date the form was showing a moment ago.
  const fetchBulkStock = async (itemIds, subInvId, asOfDate) => {
    const stockMap = {};
    const ids = [...new Set((itemIds || []).filter(Boolean))];
    if (ids.length === 0) return stockMap;
    try {
      const stockData = await getBulkItemQtyAmt(
        ids.map((ITEM_ID) => ({ ITEM_ID })),
        subInvId,
        asOfDate
      );
      (stockData || []).forEach((row) => {
        if (row?.stockInfo) stockMap[row.ITEM_ID] = row.stockInfo;
      });
    } catch (error) {
      console.error("Error fetching bulk item quantity and amount:", error);
    }
    return stockMap;
  };
  // Same shape the per-row itemQtyAmt returned, so the call sites read unchanged.
  const stockOf = (stockMap, itemId) => {
    const info = stockMap[itemId];
    return {
      stockQty: Number(info?.item_Qty) || 0,
      rate: Number(info?.item_Rate) || 0,
    };
  };

  const itemTypeLov = (itemId, index) => {
    let itemTypedata = [];

    axios
      .post(
        `${baseurl}/lovs/getItemType`, //query se hm item Id k against is lye handle nhi kr rhy qk hoskta h ye query kahi or b use horhi ho
        { companyId: companyId, username: username },
        {
          headers: {
            authorization: token,
          },
        }
      )
      .then((response) => {
        let responseData = response.data.data;

        if (!itemId) {
          for (let loop = 0; loop < responseData.length; loop++) {
            itemTypedata.push({
              id: responseData[loop]?.ITEM_TYPE_ID,
              label: `${responseData[loop]?.ITEM_TYPE_DESC}`,
              itemId: responseData[loop]?.itemId,
            });
          }
          setGetDataItemType({
            ...getDataItemType,
            itemTypeOptions: itemTypedata,
          });
        } else {
          for (let loop = 0; loop < responseData.length; loop++) {
            if (itemId == responseData[loop]?.ITEM_TYPE_ID) {
              itemTypedata.push({
                id: responseData[loop]?.ITEM_TYPE_ID,
                label: `${responseData[loop]?.ITEM_TYPE_DESC}`,
                itemId: responseData[loop]?.itemId,
              });
              let itemType = itemTypedata[0];
            }
            setData({
              ...data,
              itemType: itemId ? itemTypedata[0] : "",
            });
          }
        }
        let formValues = data.formValues;
        // formValues[index]["itemLov"] = [...itemTypedata];
        if (itemId) {
          formValues[index]["itemType"] = [...itemTypedata];
        }
        setData({
          ...data,
          formValues,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };
  // Update mode, date changed after the detail is already written: keep the
  // lines and re-read stock + rate for every item as at the new date, instead of
  // wiping the grid the way add mode does. Qty is kept as entered; amount is
  // re-derived from the new rate. A line with no stock at the new date comes
  // back at rate 0, which handleSubmit's "greater than 0" check then blocks, so
  // the user is told which item needs fixing rather than saving a zero line.
  const recallDetailStock = async (newDate) => {
    const lines = data.formValues || [];
    const itemIds = lines.map((line) => line?.uom?.id);
    setLoadingResponce(true);
    const stockMap = await fetchBulkStock(itemIds, fSubInv?.id, newDate);
    const formValues = lines.map((line) => {
      if (!line?.uom?.id) return line;
      const { stockQty, rate } = stockOf(stockMap, line.uom.id);
      const itemRate = parseFloat(Number(rate).toFixed(2));
      return {
        ...line,
        stockQty: parseFloat(Number(stockQty).toFixed(2)),
        itemRate,
        recipeAmount: stringToNumber(line.recipeQty) * itemRate,
      };
    });
    reCalculate(formValues);
    setData({
      ...data,
      formValues,
    });
    setLoadingResponce(false);

    const shortLines = formValues.filter(
      (line) =>
        line?.uom?.id && stringToNumber(line.recipeQty) > (line.stockQty || 0)
    );
    if (shortLines.length) {
      swal({
        title: "Stock is short on the new date",
        text: shortLines
          .map(
            (line) =>
              `${line.uom?.label}: Qty ${line.recipeQty}, Stock ${line.stockQty || 0}`
          )
          // sweetalert collapses newlines in `text`, so keep it on one line
          .join(" | "),
        icon: "warning",
      });
    }
  };

  const Toggle = (value, e) => {
    const hasDetail = (data.formValues || []).some((line) => line?.uom?.id);
    if (!value && updateCheck === 2 && hasDetail) {
      Swal.fire({
        title: "Change document date?",
        text: "Stock and rate of the item detail will be recalled for the new date.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, change date",
        cancelButtonText: "Cancel",
      }).then((result) => {
        if (result.isConfirmed) {
          setDate(e);
          checkDateOfYear(e);
          recallDetailStock(e);
        }
      });
      return;
    }
    Swal.fire({
      title: "Change document date?",
      text: "The item detail entered so far will be cleared.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, change date",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        if (value) {
          setShowSchedule(value);
        } else {
          setDate(e);
          checkDateOfYear(e);
        }

        let nulArr = [];
        const nulObj = {
          lineNum: 1,
          uom: null,
          uomName: "",
          recipeQty: 0,
          itemRate: 0,
          recipeAmount: 0,
          remarks: "",
        };
        setTotalValues({
          ...totalValues,
          totalQty: 0,
          totalAmount: 0,
        });
        nulArr.push(nulObj);
        setData({
          ...data,
          formValues: nulArr,
        });
      }
    });
  };
  const pendingDemands = () => {
    setShowModal(!showModal);

    setData({
      ...data,
      formValues: [
        {
          lineNum: 1,
          itemType: null,
          itemTypeId: null,
          itemLov: [],
          itemCode: null,
          itemCodeLov: [],

          itemDescription: "",
          uomName: "",
          recipeQty: recipeQty,
          itemRate: null,
          recipeAmount: null,
          remarks: "",
        },
      ],
    });
  };
  const inputEvent = (e, index) => {
    let formValues = data.formValues;
    const value = e.target.value;
    const name = e.target.name;

    // Step 1: Remove all commas using replace with a regular expression
    const valueWithoutCommas = value.replace(/,/g, "");

    // Step 2: Convert the resulting string to a number
    const numericValue = Number(valueWithoutCommas);

    let itemRate = formValues[index]["itemRate"];
    let itemQty = formValues[index]["recipeQty"];
    let amount = numericValue * itemRate;
    let amount2 = numericValue * itemQty;
    let recipeQty = value / itemRate;

    if (name === "recipeQty") {
      if (
        // formValues[index]["recipeQty2"] >= numericValue && //demand is not being used in crumble 15 may 25
        formValues[index]["stockQty"] >= numericValue
      ) {
        formValues[index]["recipeQty"] = numericValue;
        formValues[index]["recipeAmount"] = amount;
        reCalculate(formValues);
      } else {
        swal({
          title: "Quantity exceeds!",
          // text: `The Qty cannot exceed Demand Qty(${formValues[index]["recipeQty"]}) and Stock Qty(${formValues[index]["stockQty"]}).`,
          text: `The Quantity cannot exceeds Stock Quantity(${formValues[index]["stockQty"]}).`,
          icon: "warning",
        });
      }
    } else if (name === "remarks") {
      formValues[index]["remarks"] = value;
    } else if (name === "amount") {
      formValues[index]["recipeAmount"] = value;
      formValues[index]["recipeQty"] = recipeQty;
    } else if (name === "itemRate") {
      formValues[index]["itemRate"] = numericValue;
      formValues[index]["recipeAmount"] = amount2;
      reCalculate(formValues);
    }
    setData({
      ...data,
      formValues,
    });
  };
  let propsData = props.location.state;

  useEffect(() => {
    checkBussinessPermission();
    checkJvAccess();
    const funCall = async (value) => {
      const openModalCheck = await asyncRollCheck(value);
    };
    let id = propsData?.rowData?.transfer_id || propsData?.id;
    let updateCheck = propsData?.updateCheck;
    itemCodeLov();
    getLovs();

    // itemTypeLov("", 0);
    if (id) {
      if (updateCheck === 1) {
        funCall(0);
      } else {
        funCall(2);
      }
      getDataWithId(id, updateCheck);
    } else {
      setShowModal(propsData?.hideCheck);
      funCall(1);
      checkDateOfYear(date);
    }
  }, []);

  // Rights are per menu link, not per record, so this runs once. Both are
  // required: seeing this form, and seeing the JV form -- being allowed to open
  // a transfer must not by itself expose its journal detail.
  const checkJvAccess = async () => {
    const [canSeeForm, canSeeJv] = await Promise.all([
      checkPermissionSilent("/inventoryTransferForm", 0),
      checkPermissionSilent("/JournalEntryAdd", 0),
    ]);
    setCanViewJv(canSeeForm && canSeeJv);
  };

  const asyncRollCheck = async (value) => {
    let pathname = "/inventoryTransferForm";
    let status = value;

    let hasPermission = await checkPermission(pathname, status);
    if (hasPermission) {
      return true;
    }
  };
    const checkBussinessPermission = async () => {
      let checkBussinessPermission = await check_Bussiness_Permission();
      console.log("checkBussinessPermission :>> ", checkBussinessPermission[0]);
      let { isEggSpectation } = checkBussinessPermission;
      if (isEggSpectation) {
        setDB({
          ...db,
          isEggSpectation,
        });
        // setShowSchedule(options[1]);
      }
    };
  const getLovs = () => {
    let SubInvData = [];
    axios
      .post(
        `${baseurl}/pointOfSale/getSubInvData`,
        // transitOnly limits the branch list to those configured for transfers;
        // ignored by clients that are not on the transit posting method
        { companyId: companyId, username: username, transitOnly: true },
        {
          headers: {
            authorization: token,
          },
        }
      )
      .then((response) => {
        let responseData = response.data.data;
        for (let loop = 0; loop < responseData.length; loop++) {
          SubInvData.push({
            id: responseData[loop]["sub_inv_id"],
            value: responseData[loop]["sub_inv_id"],
            label: responseData[loop]["sub_inv_desc"],
          });
        }
        setSubInvLov(SubInvData);
        // setLoadingResponce(false);
      })
      .catch((err) => {
        console.log(err);
        setLoadingResponce(false);
      });
  };
  const pendingTransferDemand = () => {
    setShowModal(!showModal);
  };

  const checkDateOfYear = async (e) => {
    let purchaseDate;
    let byDefault;
    if (e === "did") {
      byDefault = "didMount";
      purchaseDate = date;
    } else {
      byDefault = "";
      purchaseDate = e;
    }
    const tableName = "inv_transfer_mt";
    const invoiceType = "";
    const invBookId = 43;
    const dateColumn = "trans_date";
    const documentNo = "doc_no";
    var myDate = moment(purchaseDate).format("YYYY-MM-DD");

    let closeDate = await CheckClosingYearD(
      myDate,
      tableName,
      invoiceType,
      invBookId,
      dateColumn,
      documentNo,
      byDefault
    );
    let purchaseNo = closeDate[1];

    if (closeDate[0] === true) {
      setDate("");
      setProductionNumber("");
    } else if (closeDate[0] === false) {
      setDate(purchaseDate);
      setProductionNumber(purchaseNo);
    } else {
      setDate("");
      setProductionNumber("");
    }
  };
  const checkNullObject = (objId, objLabel) => {
    return objId ? { id: objId, label: objLabel } : null;
  };
  const multiSelection = async (modalArr) => {
    console.log("DAta>>", modalArr);

    setTSubInv(
      checkNullObject(modalArr[0].fr_sub_inv_id, modalArr[0].fr_sub_inv_desc)
    );
    setFSubInv(
      checkNullObject(modalArr[0].to_sub_inv_id, modalArr[0].to_sub_inv_desc)
    );
    let mainArray = data.formValues;
    let array1 = [];
    let element;
    setLoadingResponce(true);
    // One bulk stock call for the whole selection instead of one per row. Keyed
    // by to_sub_inv_id because the rate is branch-specific; in practice the modal
    // hands back a single branch -- the setTSubInv/setFSubInv above already assume
    // that -- so this is normally a single call.
    const stockMaps = {};
    for (const subInvId of [
      ...new Set(modalArr.map((r) => r["to_sub_inv_id"])),
    ]) {
      stockMaps[subInvId] = await fetchBulkStock(
        modalArr
          .filter((r) => r["to_sub_inv_id"] === subInvId)
          .map((r) => r["item_id"]),
        subInvId,
        date
      );
    }
    for (let i = 0; i < modalArr.length; i++) {
      element = modalArr[i];
      let { stockQty: qty, rate } = stockOf(
        stockMaps[element["to_sub_inv_id"]] || {},
        element["item_id"]
      );
      const uom = {
        id: element["item_id"],
        label: element["ITEM_CODE"] + " " + element["ITEM_DESC"],
        value: element["item_id"],
        itemCode: element["ITEM_CODE"],
      };
      const uomName = element["UOM_DESC"];
      // const itemRate = element["itemRate"];
      // const recipeAmount = element["amount"];
      const itemRate = parseFloat(Number(rate).toFixed(2)); // amount / element["pending_demand"];
      const recipeQty = element["pending_demand"];
      const recipeQty2 = element["pending_demand"];
      const doc_no = element["doc_no"];
      // const stockQty = qty;
      const stockQty = parseFloat(Number(qty).toFixed(2)); // number 12.34

      // const dQty = ;
      const recipeAmount = parseFloat(Number(rate).toFixed(2)) * recipeQty;
      const demandId = element["id"];

      array1.push({
        uom,
        uomName,
        stockQty,
        recipeQty,
        recipeQty2,
        doc_no,
        itemRate,
        recipeAmount,
        demandId,
      });
      // console.log("array1====", array1);
    }

    if (mainArray.length === 1 && !mainArray[0].uom) {
      reCalculate(array1);
      setData({
        ...data,
        formValues: array1,
      });
    } else {
      // const formValues = [...data.formValues, ...array1];
      // reCalculate(formValues);

      // setData({
      //   ...data,
      //   formValues,
      // });
      reCalculate(array1);
      if (array1.length === 0) {
        setData({
          ...data,
          formValues: [
            {
              lineNum: 1,
              itemType: null,
              itemTypeId: null,
              itemLov: [],
              itemCode: null,
              itemCodeLov: [],

              itemDescription: "",
              uomName: "",
              recipeQty: recipeQty,
              itemRate: null,
              recipeAmount: null,
              remarks: "",
            },
          ],
        });
      } else {
        setData({
          ...data,
          formValues: array1,
        });
      }
    }
    setLoadingResponce(false);
  };

  const getDataWithId = (id, updateCheck) => {
    setLoadingResponce(true);
    axios
      .post(
        `${baseurl}/pointOfSale/getInventoryMasterById`,
        {
          id: id,
          companyId: companyId,
          username: username,
        },
        {
          headers: {
            authorization: token,
          },
        }
      )
      .then(async (res) => {
        let response = res.data.data;
        let resDataMt = res.data.data[0];
        let resDataDet = res.data.data1;

        // 0 = add, 1 = disabled, 2 = update
        if (updateCheck === 1) {
          setDisabledState(true);
        }

        // authoritative source for the JV button -- the row handed over by the
        // overview is only a seed and is absent on some routes
        setJvJournalId(resDataMt?.journal_id || null);

        const {
          DATE,
          doc_no,
          remarks,
          fr_sub_inv_id,
          from_desc,
          to_sub_inv_id,
          to_desc,
          rect_date,
        } = resDataMt;

        let date = new Date(DATE);
        setFSubInv(checkNullObject(fr_sub_inv_id, from_desc));
        setTSubInv(checkNullObject(to_sub_inv_id, to_desc));

        let rectDate =
          rect_date === "0000-00-00" || !rect_date ? null : new Date(rect_date);

        if (rectDate) {
          setShowSchedule(options[1]);
        } else {
          console.warn("Invalid date value");
          setShowSchedule(options[0]);
        }

        setDate(date);
        setMainDate(date)
        setProductionNumber(doc_no);
        setRemarks(remarks);
        setUpdateCheck(updateCheck);
        setPk_id(id);

        // Stock for the whole grid in one call, read as at the transfer's own
        // date -- `date` here is the local const built from the master row, not
        // the `date` state, which the setDate(date) above has not updated inside
        // this closure. The state still held today, so the Stock(n) shown next to
        // each line (and the cap it puts on the issue qty) was read at the wrong
        // date on any transfer that is not dated today.
        const stockMap =
          updateCheck !== 1
            ? await fetchBulkStock(
                resDataDet.map((item) => item.item_id),
                fr_sub_inv_id,
                date
              )
            : {};
        let formValues = [];
        for (let index = 0; index < resDataDet.length; index++) {
          const {
            ITEM_TYPE_ID,
            ITEM_TYPE_DESC,
            item_id,
            ITEM_CODE,
            ITEM_DESC,
            UOM_DESC,
            itemName,
            qty,
            orig_Qty,
            orig_Amt,
            ItemRate,
            amount,
            remarks,
            demandId,
          } = resDataDet[index];
          let stockQty = 0;
          if (updateCheck !== 1) {
            stockQty = stockOf(stockMap, item_id).stockQty;
          }
          formValues.push({
            uom: checkNullObject(item_id, itemName),
            uomName: UOM_DESC,
            recipeQty:orig_Qty, // qty,
            itemRate: orig_Amt / orig_Qty,
            recipeAmount:orig_Amt, // amount,
            remarks: remarks,
            item_id: item_id,
            ITEM_CODE: ITEM_CODE,
            demandId: demandId,
            stockQty: stockQty,
          });
        }
        reCalculate(formValues);
        let value = formValues[0].demandId ? options[1] : options[0];
        // setShowSchedule(value);// demand is not being used in crumble 15 may 25
        setData({
          ...data,
          formValues,
        });
        setMainArray(formValues);
        setLoadingResponce(false);
      })
      .catch((err) => {
        setLoadingResponce(false);
        console.log(err);
      })
      .finally(function () {
        setLoadingResponce(false);
      });
  };
  const getUserIp = async function () {
    let res = await GetIp();
    return {
      userIp: res.ip,
      userCountry: res.country,
    };
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoadingResponce(true);

    var companyId = localStorage.getItem("companyId");
    let { userIp, userCountry } = await getUserIp();

    let checkRequired = true;
    for (let index = 0; index < data.formValues.length; index++) {
      const element = data.formValues[index];
      // console.log("hello", element?.recipeAmount);

      if (
        !element?.recipeAmount ||
        element.recipeAmount <= 0 ||
        !element?.recipeQty ||
        element.recipeQty <= 0
      ) {
        checkRequired = false;
        setLoadingResponce(false);
        swal({
          title: "Required!",
          text: `In "${element.uom.label}" Quantity, Rate and Amount must be greater than 0.`,
          icon: "warning",
        });
        break;
      }
    }
    if (checkRequired) {
      if (propsData?.updateCheck === 2) {
        let id = propsData?.rowData.transfer_id || propsData?.id;
        axios
          .post(
            `${baseurl}/pointOfSale/updateInventoryMaster`,
            {
              id,
              companyId,
              date: moment(date).format("YYYY-MM-DD"),
              mainDate: mainDate,
              productionNumber: productionNumber,
              showSchedule:options[0],
              remarks: remarks ? remarks : "",
              fInvenId: fSubInv?.id,
              tInvenId: tSubInv?.id,
              detailArray: data.formValues,
              username: username,
              mainArray: mainArray,
              userIp,
              userCountry,
            },
            {
              headers: {
                authorization: token,
              },
            }
          )

          .then(function (response) {
            if (response.data?.message === "Negavtive Item") {
              // rolled back on the server -- leave the form editable so the
              // quantities can be corrected
              swal({
                title: `Item of code ${
                  response.data?.itemCode
                } is being negative on ${moment(response.data?.resDate).format(
                  "DD, MMM YYYY"
                )}`,
                text: "issue",
                icon: "error",
              });

              // this.toggle();
            } else {
              setDisabledState(true);
              if (response.data?.journalID) {
                setJvJournalId(response.data.journalID);
              }
              swal({
                title: "Success!",
                text: "Inventory Master Updated!",
                icon: "success",
              }).then((value) => {
              });
            }
          })
          .catch(function (error) {
            console.log(error);

            swal({
              title: "Error!",
              text: error.response.data.message,
              icon: "error",
            });
          })
          .finally(function () {
            setLoadingResponce(false);
          });
      } else {
        console.log("data.formValues", data.formValues);
        axios
          .post(
            `${baseurl}/pointOfSale/addInventoryTransfer`,
            {
              companyId,
              
              date: moment(date).format("YYYY-MM-DD"),
              productionNumber: productionNumber,
              showSchedule:options[0],
              remarks: remarks ? remarks : "",
              fInvenId: fSubInv?.id,
              tInvenId: tSubInv?.id,
              detailArray: data.formValues,
              username: username,
              userIp,
              userCountry,
            },
            {
              headers: {
                authorization: token,
              },
            }
          )
          .then(function (response) {
            // let doc_No = response.data?.latestDocNo;

            if (response.data?.message === "Negavtive Item") {
              // a rejection, not a save -- the server rolled back, so the form
              // must stay editable for the user to correct the quantities
              swal({
                title: `Item of code ${
                  response.data?.itemCode
                } is being negative on ${moment(response.data?.resDate).format(
                  "DD, MMM YYYY"
                )}`,
                text: "issue",
                icon: "error",
              });

              // this.toggle();
            } else {
              setDisabledState(true);
              // posted JV comes back on the response, so "Print JV" can appear
              // straight after saving
              if (response.data?.journalID) {
                setJvJournalId(response.data.journalID);
              }
              swal({
                title: "Saved Successfully!",
                text: "Inventory Transfer ",
                icon: "success",
              }).then((value) => {
              });
            }
          })
          .catch(function (error) {
            swal({
              title: "Error!",
              text: error.response.data.message,
              icon: "error",
            });
          })
          .finally(function () {
            setLoadingResponce(false);
          });
      }
    } else {
      setLoadingResponce(false);
      // swal({
      //   title: "Amount",
      //   text: "Amount must be greater than 0.",
      //   icon: "warning",
      // });
    }
  };
  return (
    <>
      {loadingResponce === true ? (
        <ResponseLoader />
      ) : (
        <div>
          <Row className="Creative-Invoice-header-styling">
            <Col xs="8" className="card-header-Creative-Invoice">
              <>
                <strong>
                  <h4>Inventory Transfer Issue</h4>
                </strong>
              </>
            </Col>
            <Col xs="4" className="card-header-Creative-Invoice">
              <div
                style={{
                  textAlign: "right",
                }}
              >
                <Link
                  to={
                    propsData?.goBackUrl
                      ? "/itemLedgerReports"
                      : "/inventoryTransferOverview"
                  }
                  style={{
                    fontFamily: "Times New Roman",
                    fontWeight: "normal",
                    margin: "10px",
                  }}
                >
                  <u className="Back-to-Overview">Back to Overview</u>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    fill="currentColor"
                    className="bi bi-chevron-left mx-2 icon-color"
                    viewBox="0 0 16 16"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"
                    />
                  </svg>
                </Link>
              </div>
            </Col>
          </Row>

          <Row>
            <Col>
              <div className="row">
                <div className="col-md-12">
                  <Form name="simpleForm" onSubmit={handleSubmit}>
                    <div className="row">
                      <div className="col-md-12">
                        <div className="row my-2" translate="no"></div>
                      </div>
                      <div
                        className="col-md-5"
                        style={{ marginBottom: "12px" }}
                      >
                        <Label style={{ fontWeight: "bold" }}>
                          From Sub-Inventory:{" "}
                          <h8 style={{ color: "tomato" }}>*</h8>
                        </Label>
                        <Select
                          isClearable
                          value={fSubInv || ""}
                          options={subInvLov}
                          onChange={(e) => handleFromChangeOpen(e)}
                          required
                          isDisabled={disabledState}
                          name="subInv"
                          placeholder={"-- Select --"}
                        />
                      </div>
                      <div
                        className="col-md-5"
                        style={{ marginBottom: "12px" }}
                      >
                        <Label style={{ fontWeight: "bold" }}>
                          To Sub-Inventory:{" "}
                          <h8 style={{ color: "tomato" }}>*</h8>
                        </Label>
                        <Select
                          isClearable
                          value={tSubInv || ""}
                          options={subInvLov}
                          onChange={(e) => handleToChangeOpen(e)}
                          required
                          isDisabled={disabledState}
                          name="subInv"
                          placeholder={"-- Select --"}
                        />
                      </div>
                      {/*  <div
                        className="col-md-2"
                        style={{ marginBottom: "12px", textAlign: "right" }}
                      >
                        <Label style={{ fontWeight: "bold" }}>
                          Auto-receipt: <h8 style={{ color: "tomato" }}>*</h8>
                        </Label>
                       <AppSwitch
                          className=" "
                          onClick={Toggle}
                          variant="pill"
                          size="lg"
                          color="primary"
                          label={
                            showSchedule ? "Hide Criteria" : "Show Criteria"
                          }
                          checked={showSchedule}
                        />
                        <SelectButton
                          // invalid
                          value={showSchedule}
                          // onChange={(e) => setShowSchedule(e.value)}
                          // onChange={(e) => Toggle(e.value)} // mene iska onchange hi bnd kr dia he bjae k me state se block krta Qk ye he hi pka pka disable islei haider bhai ne kha tha (Saif)
                          className="small-select-button" // Applying custom class
                          options={options}
                          disabled={true}
                        />
                      </div> */}
                      <ReactDatePicker
                        label="Date:"
                        isSelected={date}
                        onChange={(e) => {
                          Toggle(null, e);
                          // setDate(e);
                          // checkDateOfYear(e);
                        }}
                        isDisabled={disabledState}
                      />
                      <div
                        className="col-md-3"
                        style={{ marginBottom: "12px" }}
                      >
                        <Label style={{ fontWeight: "bold" }}>
                          Doc No. <span style={{ color: "tomato" }}>*</span>
                        </Label>

                        <Input
                          type="number"
                          className="form-control"
                          name="productionNumber"
                          id="productionNumber"
                          onChange={(e) => {
                            setProductionNumber(e.target.value);
                          }}
                          required
                          value={productionNumber}
                          // disabled={disabledState}
                          disabled
                        />
                      </div>
                      <div
                        className="col-md-4"
                        style={{ marginBottom: "12px" }}
                      >
                        <Label style={{ fontWeight: "bold" }}>Remarks</Label>
                        <Input
                          type="text"
                          className="form-control"
                          name="remarks"
                          id="remarks"
                          onChange={(e) => {
                            setRemarks(e.target.value);
                          }}
                          value={remarks ? remarks : ""}
                          disabled={disabledState}
                        />
                      </div>
                      {propsData?.hideCheck ? (
                        <div
                          className="col-md-2 col-lg-2 col-xl-2 my-1"
                          style={{
                            textAlign: "right",
                          }}
                        >
                          <span className="  ">
                            <Button
                              style={{
                                background: "#034098",
                                color: "white",
                                height: "36px",
                                marginTop: "20px",
                              }}
                              className="button add"
                              type="button"
                              size="sm"
                              disabled={
                                disabledState
                                //  ||
                                // (fSubInv?.id &&
                                // tSubInv?.id &&
                                // showSchedule === "On"
                                //   ? false
                                //   : true)
                              }
                              onClick={() => setShowModal(!showModal)}
                              // onClick={pendingDemands}
                            >
                              {/* <i className="fa fa-search"></i> */}
                              Pending Demands
                            </Button>
                          </span>
                        </div>
                      ) : null}
                      <div className="col-md-12 mb-2">
                        {data.formValues.map((element, index) => (
                          <div className="div my-1">
                            <div className="InvoiceLine-styling ">
                              <div class="row">
                                <div className="col-md-3 col-lg-3 col-xl-3  InvoiceLineHeading">
                                  <h6>Line.No# {index + 1} </h6>
                                </div>
                                <div className="col-md-6 col-lg-6 col-xl-6  "></div>
                                {element?.uom?.id ? (
                                  <div className="col-md-3 col-lg-3 col-xl-3  InvoiceLineHeading">
                                    <h6>Demand.No# {element.doc_no} </h6>
                                  </div>
                                ) : null}
                              </div>
                              <div class="row">
                                {/* <div
                                  className="col-md-2"
                                  style={{ marginBottom: "12px" }}
                                >
                                  <Label style={{ fontWeight: "bold" }}>
                                    Item Type:
                                    <span style={{ color: "tomato" }}>*</span>
                                  </Label>

                                  <Select
                                    // key={JSON.stringify(element.itemType)}
                                    value={element.itemType}
                                    onChange={(e) =>
                                      selectItemTypeEvent(e, index)
                                    }
                                    options={itemLov}
                                    required
                                    name="itemType"
                                    isDisabled={disabledState}
                                    isClearable
                                    placeholder={"-- Select --"}
                                  />

                                  {requiredCheck && !element.itemType?.id ? (
                                    <div style={{ color: "red" }}>
                                      <p>Please Select Item Type</p>
                                    </div>
                                  ) : null}
                                </div> */}
                                <div className="col-md-4 ">
                                  <div className="row">
                                    <div className="col-3">
                                      <Label
                                        translate="yes"
                                        //
                                      >
                                        Item:
                                        <span className="text-danger">*</span>
                                      </Label>
                                    </div>
                                    {/* {!pk_id ? ( */}{" "}
                                    {/* Update par kesi bi form par stock show ni hona.. untill unless sir asked for it (pr ye tauqeer ne on krwaya he update pr 22-May)*/}
                                    <div
                                      className="col-9"
                                      style={{ textAlign: "right" }}
                                    >
                                      {!disabledState && (element?.stockQty
                                        ? `${fSubInv?.label}.Stock(${element?.stockQty})`
                                        : element.uom
                                        ? "Stock(0)"
                                        : "")}
                                    </div>
                                    {/*  ) : null} */}
                                  </div>

                                  <Select
                                    value={element.uom}
                                    onChange={(e) => selectUOMEvent(e, index)}
                                    options={itemLov1}
                                    required
                                    name="uom"
                                    isDisabled={
                                      disabledState ||
                                      !fSubInv?.id ||
                                      !tSubInv?.id
                                      // ||
                                      // showSchedule === "On"
                                      //   ? true
                                      //   : false
                                    }
                                    placeholder={
                                      localStorage.getItem("comp_lang") == "ur"
                                        ? "--Ù…Ù†ØªØ®Ø¨ Ú©Ø±ÛŒÚº--"
                                        : localStorage.getItem("comp_lang") ==
                                          "ar"
                                        ? "--ÙŠØ®ØªØ§Ø±--"
                                        : "--select--"
                                    }
                                    isClearable
                                  />
                                </div>
                                {/* <div className="col-md-2">
                                  <Label style={{ fontWeight: "bold" }}>
                                    Item Description
                                    <span style={{ color: "tomato" }}>*</span>
                                  </Label>
                                  <Input
                                    type="text"
                                    className="form-control"
                                    name="itemDescription"
                                    id="itemDescription"
                                    // onChange={inputEvent}
                                    required
                                    value={element.itemDescription}
                                    disabled={true}
                                  />
                                </div> */}
                                <div className="col-md-1">
                                  <Label style={{ fontWeight: "bold" }}>
                                    UOM
                                    <span style={{ color: "tomato" }}>*</span>
                                  </Label>
                                  <Input
                                    type="text"
                                    id="uomName"
                                    name="uomName"
                                    className="form-control"
                                    disabled={true}
                                    value={element.uomName}
                                    // onChange={(e) => {
                                    //   this.handleChangeItemLovs(index, e);
                                    // }}
                                    required
                                  ></Input>
                                </div>
                                <div className="col-md-1">
                                  {/* <Label style={{ fontWeight: "bold" }}>
                                    Qty
                                    <span style={{ color: "tomato" }}>*</span>
                                  </Label> */}

                                  <div className="row">
                                    <div className="col-3">
                                      <Label
                                        translate="yes"
                                        //
                                      >
                                        Quantity
                                        <span className="text-danger">*</span>
                                      </Label>
                                    </div>
                                    <div
                                      className="col-9"
                                      style={{ textAlign: "right" }}
                                    >
                                      {element?.recipeQty2
                                        ? `(${element?.recipeQty2})`
                                        : ""}
                                    </div>
                                  </div>
                                  <NumberFormat
                                    name="recipeQty"
                                    id="recipeQty"
                                    className="form-control"
                                    style={{ textAlign: "right" }}
                                    thousandSeparator={true}
                                    // value={element.qty || ""}
                                    value={element.recipeQty}
                                    // fixedDecimalScale={true}
                                    decimalScale={3}
                                    fixedDecimalScale
                                    placeholder="0.000"
                                    allowNegative={false}
                                    isNumericString
                                    disabled={disabledState}
                                    onChange={(e) => inputEvent(e, index)}
                                    // disabled={this.state.disabled ? true : false}
                                    required
                                  />
                                </div>
                                <div className="col-md-1">
                                  <Label style={{ fontWeight: "bold" }}>
                                    Rate
                                    <span style={{ color: "tomato" }}>*</span>
                                  </Label>
                                  <NumberFormat
                                    id="itemRate"
                                    name="itemRate"
                                    className="form-control"
                                    disabled={true}
                                    decimalScale={3}
                                    fixedDecimalScale
                                    placeholder="0.000"
                                    allowNegative={false}
                                    value={element.itemRate}
                                    isNumericString
                                    thousandSeparator={true}
                                    // disabled={disabledState}
                                    onChange={(e) => inputEvent(e, index)}
                                    required
                                    isAllowed={(values) => {
                                      const { floatValue } = values;
                                      // Allow empty or valid value
                                      if (floatValue > 0) {
                                        return true;
                                      } else {
                                        // Trigger warning when exceeding
                                        swal({
                                          title: "Rate Zero",
                                          text: "Rate can't be Zero",
                                          icon: "warning",
                                          timer: 2000,
                                          buttons: false,
                                        });
                                        return false; // block input
                                      }
                                    }}
                                  />
                                </div>
                                <div className="col-md-1">
                                  <Label style={{ fontWeight: "bold" }}>
                                    Amount
                                    <span style={{ color: "tomato" }}>*</span>
                                  </Label>
                                  <NumberFormat
                                    name="amount"
                                    id="amount"
                                    className="form-control"
                                    style={{ textAlign: "right" }}
                                    thousandSeparator={true}
                                    // value={element.qty || ""}
                                    value={element.recipeAmount || ""}
                                    allowNegative={false}
                                    // fixedDecimalScale={true}
                                    isNumericString
                                    decimalScale={3}
                                    // disabled={disabledState}
                                    disabled
                                    fixedDecimalScale
                                    placeholder="0.000"
                                    onChange={(e) => inputEvent(e, index)}
                                    // disabled={this.state.disabled ? true : false}
                                    required
                                  />
                                </div>
                                <div className="col-md-2">
                                  <Label style={{ fontWeight: "bold" }}>
                                    Remarks
                                    {/* <h8 style={{ color: "tomato" }}>*</h8> */}
                                  </Label>

                                  <Input
                                    type="text"
                                    className="form-control"
                                    name="remarks"
                                    id="remarks"
                                    disabled={disabledState}
                                    onChange={(e) => inputEvent(e, index)}
                                    value={element.remarks}
                                  />
                                </div>
                                <div className="col-md-2 pt-4 mt-1">
                                  <div>
                                    <Button
                                      className="btn btn-info text-white mx-2"
                                      type="button"
                                      size="sm"
                                      onClick={() => addFormFieldsItem()}
                                      disabled={
                                        disabledState || !fSubInv?.id
                                        // ||
                                        // showSchedule === "On"
                                        //   ? true
                                        //   : false
                                      }
                                      // title={tooltipText.addMulLineInv}
                                    >
                                      <i className="fa fa-plus "></i>
                                    </Button>

                                    <Button
                                      type="button"
                                      size="sm"
                                      className="btn btn-danger "
                                      disabled={disabledState}
                                      onClick={() =>
                                        removeFormFieldsItem(index)
                                      }
                                      title={tooltipText.remMulLineInv}
                                      // disabled={disabled ? true : false }
                                    >
                                      <i className="fa fa-trash "></i>
                                    </Button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                        <div className="row mt-4">
                          <div className="card-header-Creative-Invoice-Totals col-md-2 col-lg-1 mt-n3 ml-3">
                            <strong>
                              <h5>Total</h5>
                            </strong>
                          </div>
                        </div>

                        <div className="div" style={{ marginTop: "7px" }}>
                          <div className="row">
                            <div className="col-md-3">
                              <Label style={{ fontWeight: "bold" }}>
                                Quantity
                              </Label>

                              <NumberFormat
                                name="totalQty"
                                className="form-control"
                                disabled
                                thousandSeparator={true}
                                value={totalValues.totalQty || "0"}
                                decimalScale={3}
                                fixedDecimalScale={true}
                                defaultValue="0.000"

                                // displayType="input"
                              />
                            </div>
                            <div className="col-md-3">
                              <Label style={{ fontWeight: "bold" }}>
                                {" "}
                                Amount
                              </Label>

                              <NumberFormat
                                name="totalAmount"
                                className="form-control"
                                disabled
                                thousandSeparator={true}
                                value={totalValues.totalAmount || "0"}
                                decimalScale={3}
                                fixedDecimalScale={true}
                                defaultValue="0.000"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <hr
                      style={{
                        border: "1px solid ",
                        marginBottom: "3vh",
                        marginTop: "3vh",
                        borderColor: "E4E5E6",
                      }}
                    />
                    <FormGroup>
                      <Button
                        disabled={
                          loadingResponce ? true : false || disabledState
                        }
                        hidden={updateCheck === 1}
                        className="mr-1 invoiceSubmitButton "
                      >
                        {updateCheck === 2 ? "Update" : "Save"} Changes
                      </Button>
                      <Link
                        to={{
                          pathname: "/inventoryTransferOverview",
                        }}
                      >
                        <Button
                          // disabled={
                          //   loadingResponce ? true : false || disabledState
                          // }
                          className="mr-1"
                          size="sm"
                          // hidden={updateCheck === 1}
                        >
                          Cancel
                        </Button>
                      </Link>

                      {/* Shown only when the user may view both this form and the
                          JV form, and only once the transfer has actually posted.
                          Opens the journal read-only so the user keeps their
                          place on the document. */}
                      {canViewJv && jvJournalId ? (
                        <Button
                          className="mr-1"
                          size="sm"
                          color="info"
                          type="button"
                          title="Print JV"
                          onClick={() => setJvModalOpen(true)}
                        >
                          Print JV
                        </Button>
                      ) : null}

                      {/* <Button
                        disabled={
                          loadingResponce ? true : false || disabledState
                        }
                        className="mr-1"
                        size="sm"
                        type="button"
                        hidden={updateCheck === 1}
                      >
                        Cancel
                      </Button> */}
                    </FormGroup>
                  </Form>
                </div>
              </div>
            </Col>
          </Row>
          <JvPreviewModal
            isOpen={jvModalOpen}
            toggle={() => setJvModalOpen(!jvModalOpen)}
            journalId={jvJournalId}
            title="Transfer Issue - Journal Voucher"
          />
          {showModal && (
            <PendingTransferDemandModal
              toggle={pendingTransferDemand}
              sub_inv_id={fSubInv?.id}
              fSubInv={fSubInv?.id}
              tSubInv={tSubInv?.id}
              tSubInvDesc={tSubInv?.label}
              fSubInvDesc={fSubInv?.label}
              date={date}
              selectedValues={data.formValues}
              // itemHealthIndex={this.state.itemHealthIndex}
              callback={(data) => multiSelection(data)}
              // callback={(index, data) =>
              //   this.handleChangeRows(index, data, "item_id")
              // }
              formcheck="0"
            />
          )}
        </div>
      )}
    </>
  );
}
